/**
 * Created by Desarrollo KJ on 20/3/2017.
 */
import { Component, Output, EventEmitter } from '@angular/core';
import { ApiService } from './../../services/api.service';
import { ToastyService } from 'ng2-toasty';
import { ViewChild } from '@angular/core';
import { ReCaptchaComponent  } from 'angular2-recaptcha/lib/captcha.component';


@Component({
  selector: 'login', // <my-app></my-app>
  template: require('./login.html')
})
export class Login{
  @ViewChild(ReCaptchaComponent) captcha: ReCaptchaComponent;
  @ViewChild(ReCaptchaComponent) captchaRecovery: ReCaptchaComponent;

  public formUser:any = {
    nombre:'',
    clave:'',
    correo:''
  };

  public formLogIn:any = {
    clave:'',
    correo:''
  };

  public formRecovery:any = {
    correo:''
  };

  public user:any = {
    nombre:''
  };

  @Output() emitControl = new EventEmitter();

  public sesionControl:any = false;
  public recoveryControl:any = false;

  constructor(private _api:ApiService, private _toasty:ToastyService) {
    if(localStorage.getItem('login')){
      this.sesionControl = true;
      this.user = JSON.parse(localStorage.getItem('login'));
    }
    // Do stuff
  }

  crearUsuario(){
    if(this.captcha.getResponse()){
      this._api.postUser(this.formUser).subscribe(
        res=>{
          console.log(res);
          this._toasty.success('¡Usuario creado con exito!');
          localStorage.setItem('login', JSON.stringify(res[0]));
          this.user = res;
          this.sesionControl = true;
          location.reload();
        },
        err => {
          let msg = JSON.parse(err._body);
          this._toasty.error(msg.message);
        }
      );
    }
    else {
      this._toasty.error('¿Es usted un robot?');
    }
  }

  solicitarRecuperacion(){
    if(this.captchaRecovery.getResponse()){
      this._api.postRecuperacion(this.formRecovery).subscribe(
        res=>{
          console.log(res);
          this._toasty.success('¡Su contraseña a sido reseteada, fovor revisar su correo para poder ver su nueva contraseña temporal!');
        },
        err => {
          let msg = JSON.parse(err._body);
          this._toasty.error(msg.message);
        }
      );
    }
    else {
      this._toasty.error('¿Es usted un robot?');
    }
  }

  iniciarSesion(){
    this._api.postLogin(this.formLogIn).subscribe(
      res=>{
        console.log(res);
        this._toasty.success('¡Usuario inicio con exito!');
        localStorage.setItem('login', JSON.stringify(res[0]));
        this.user = res[0];
        this.sesionControl = true;
        location.reload();
      },
      err => {
        let msg = JSON.parse(err._body);
        this._toasty.error(msg.message);
      }
    );
  }

  cerrarSesion(){
    localStorage.removeItem('login');
    this.sesionControl = false;
    location.reload();
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/login/login.component.ts